import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

const proFeatures = [
  "Unlimited storage",
  "Contacts & companies",
  "Deals & tasks",
  "Cases & calls",
  "Calendar & docs",
  "Reports",
  "iOS & Android apps",
  "Campaigns & forms",
  "Email",
  "Google Sync",
  "QuickBooks",
  "SMS",
  "Voice calling",
  "Credit card",
  "Customer Support",
];

const enterpriseFeatures = [...proFeatures, "API access"];

const tiers = [
  {
    name: "Free",
    price: "$0",
    blurb: "Free forever — the essentials to manage contacts, deals, and tasks.",
    features: [
      "Unlimited storage",
      "Contacts & companies",
      "Deals & tasks",
      "Cases & calls",
      "Calendar & docs",
      "Reports",
      "iOS & Android apps",
      "No Support",
    ],
    cta: "Sign up free",
    highlight: false,
  },
  {
    name: "Pro",
    price: "$10",
    blurb: "Full CRM power for growing sales teams.",
    features: proFeatures,
    cta: "Sign up",
    highlight: true,
  },
  {
    name: "Enterprise",
    price: "$25",
    blurb: "Advanced features for high-volume teams.",
    features: enterpriseFeatures,
    cta: "Sign up",
    highlight: false,
  },
];

const Pricing = () => {
  return (
    <section id="pricing" className="py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">Pricing</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            CRM software pricing
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            US phone numbers only $1.15/month &middot; $0.01 per minute &middot; $0.01 per SMS
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {tiers.map((t) => (
            <div
              key={t.name}
              className={`relative flex flex-col rounded-2xl border bg-card p-8 transition-all ${
                t.highlight
                  ? "border-primary shadow-elegant lg:scale-105"
                  : "border-border shadow-card hover:-translate-y-1 hover:shadow-soft"
              }`}
            >
              {t.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-gradient-primary px-3 py-1 text-xs font-semibold text-primary-foreground shadow-soft">
                  Most popular
                </span>
              )}
              <h3 className="font-display text-2xl font-bold text-secondary">{t.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{t.blurb}</p>
              <div className="mt-6 flex items-baseline gap-1">
                <span className="font-display text-5xl font-extrabold text-secondary">{t.price}</span>
                {t.price !== "Custom" && <span className="text-muted-foreground">/user/mo</span>}
              </div>
              <ul className="mt-6 flex-1 space-y-3">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-secondary">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                    {f}
                  </li>
                ))}
              </ul>
              <Button asChild variant={t.highlight ? "hero" : "outline"} size="lg" className="mt-8 w-full">
                <a href="https://api.freecrm.com/register/?lang=en" target="_blank" rel="noopener noreferrer">
                  {t.cta}
                </a>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
